import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Retired name. The chat is `MaJourneys AI` now and lives at `/{lang}/ai-chat`,
 * which is a landing page around the live panel rather than the bare panel
 * this URL used to serve.
 *
 * The URL stays alive because it was indexed: a 301 (never the default 307)
 * so Google folds its signal into the page that replaced it. The old
 * `ConciergePage` component was deleted as dead code (2026-09-30); git
 * history has it if that layout is wanted again.
 */
export const Route = createFileRoute("/$lang/_layout/concierge")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$lang/ai-chat",
      params: { lang: (params as { lang?: string }).lang ?? "en" },
      statusCode: 301,
      replace: true,
    });
  },
});
